let lastTouchOpener;
let touchActivation;

const desktopMenu = (target) => {
  if (!(target instanceof Element) || !window.matchMedia('(min-width: 750px)').matches) return null;
  const menu = target.closest('header-menu');
  return menu?.closest('header-component')?.dataset.menuStyle === 'menu' ? menu : null;
};

document.addEventListener('pointerdown', (event) => {
  const menu = desktopMenu(event.target);
  touchActivation = menu && event.pointerType !== 'mouse' ? event.target.closest('.menu-list__link[aria-controls]') : null;
}, { capture: true, passive: true });

document.addEventListener('click', (event) => {
  const menu = desktopMenu(event.target);
  if (!menu || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest('a[href]');
  if (!link || link.hasAttribute('download') || (link.target && link.target.toLowerCase() !== '_self')) return;
  if (link === touchActivation) {
    touchActivation = null;
    if (lastTouchOpener !== link || link.ariaExpanded !== 'true') {
      event.preventDefault();
      lastTouchOpener = link;
      link.focus({ preventScroll: true });
      menu.activate({ target: link, type: 'click' });
      return;
    }
  }
  lastTouchOpener = null;
  if (link.closest('.seal-desktop-navigation') && link.hash && link.origin === location.origin && link.pathname === location.pathname && link.search === location.search) menu.close();
}, { capture: true });
